import { addSlidesTabIndex } from '@parent-theme/assets/js/helpers/swiper/add-slides-tab-index';

const dynamicSliderInit = () => {
    const mainPattern = document.querySelectorAll('.gg-insights-carousel');

    mainPattern.forEach((module) => {
        const swipers = module.querySelector('.posts-result');
        const postContainer = module.querySelector('.posts-result__container');
        const swiperWrapper = module.querySelector('.gravity-block-dynamic-boxes--grid-view');
        const swiperSlides = module.querySelectorAll('.gravity-block-dynamic-boxes__box:not(.swiper-slide-duplicate)');
        const arrowsContainer = module.querySelector('.gg-insights-carousel__arrows');
        let swiperPrev = module.querySelector('.gg-insights-carousel__prev-btn');

        if (!swiperPrev) {
            const prevButton = document.createElement('div');
            prevButton.className = 'wp-block-button gg-insights-carousel__prev-btn is-style-button-v6';
            prevButton.setAttribute('aria-label', 'Previous slide');

            const link = document.createElement('a');
            link.className = 'wp-block-button__link wp-element-button';

            prevButton.appendChild(link);
            arrowsContainer.appendChild(prevButton);
            swiperPrev = prevButton;
        }
        let swiperNext = module.querySelector('.gg-insights-carousel__next-btn');
        if (!swiperNext) {
            const nextButton = document.createElement('div');
            nextButton.className = 'wp-block-button gg-insights-carousel__next-btn is-style-button-v6';
            nextButton.setAttribute('aria-label', 'Next slide');

            const link = document.createElement('a');
            link.className = 'wp-block-button__link wp-element-button';

            nextButton.appendChild(link);
            arrowsContainer.appendChild(nextButton);
            swiperNext = nextButton;
        }

        if (!swipers || !swiperWrapper) {
            return;
        }

        let swiperPagination = module.querySelector('.swiper-pagination');
        if (!swiperPagination) {
            swiperPagination = document.createElement('div');
            swiperPagination.className ='swiper-pagination';
            const previousDiv = arrowsContainer ? arrowsContainer.previousElementSibling : null;
            if (previousDiv) {
                previousDiv.appendChild(swiperPagination);
            }
        }

        const getSlidesPerView = () => {
            const width = window.innerWidth;
            if (width >= 1200) return 3;
            if (width >= 1025) return 3;
            if (width >= 750) return 2;
            if (width >= 480) return 1;
            return 1;
        };

        const slidesPerView = getSlidesPerView();

        if (swiperSlides.length <= slidesPerView) {
            if (swiperNext) swiperNext.style.display = 'none';
            if (swiperPrev) swiperPrev.style.display = 'none';
            if (swipers.swiper) {
                swipers.swiper.destroy(true, true);
            }
            swipers.classList.remove('swiper-container');
            swiperWrapper.classList.remove('swiper-wrapper');
            swiperSlides.forEach((slide) => {
                slide.classList.remove('swiper-slide');
            });
            if (postContainer) postContainer.style.gap = '20px';
            return;
        } else {
            if (swiperNext) swiperNext.style.display = 'block';
            if (swiperPrev) swiperPrev.style.display = 'block';
            if (postContainer) postContainer.style.gap = '0';
        }

        if (swipers.swiper) {
            swipers.swiper.destroy(true, true);
        }

        swipers.classList.add('swiper-container');
        swiperWrapper.classList.add('swiper-wrapper');
        swiperSlides.forEach((slide) => {
            slide.classList.add('swiper-slide');
        });

        const carousel = new window.Swiper(swipers, {
            loop: true,
            centeredSlides: false,
            watchOverflow: false,
            watchSlidesProgress: true,
            slidesPerGroup: 1,
            slidesPerView: slidesPerView,
            allowTouchMove: true,
            autoplay: {
                delay: 4000,
            },
            navigation: {
                prevEl: swiperPrev,
                nextEl: swiperNext,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                1025: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                750: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                480: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                200: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
            },
            on: {
                init: (swiper) => addSlidesTabIndex(swiper),
                slideChange: (swiper) => addSlidesTabIndex(swiper),
            },
        });

        swipers.swiper = carousel;

        carousel.init();
    });
};
window.addEventListener('done-check-state-v2', () => {
    setTimeout(() => {
        dynamicSliderInit()
  }, 500)
});
dynamicSliderInit();

const debounce = (func, wait) => {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
};

window.addEventListener('resize', debounce(() => {
    dynamicSliderInit();
}, 200));

function setupRoleButtonRemoval() {
    const carousels = document.querySelectorAll('.gg-insights-carousel');
    
    if (!carousels.length) return;
    
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'role') {
                const target = mutation.target;
                
                if ((target.classList.contains('gg-insights-carousel__prev-btn') || 
                     target.classList.contains('gg-insights-carousel__next-btn')) && 
                    target.getAttribute('role') === 'button' && 
                    target.querySelector('a')) {
                    
                    target.removeAttribute('role');
                }
            }
        });
    });
    
    const config = { 
        attributes: true,
        subtree: true,
        attributeFilter: ['role']
    };
    
    carousels.forEach(carousel => {
        observer.observe(carousel, config);
    });
    
    document.querySelectorAll('.gg-insights-carousel__prev-btn, .gg-insights-carousel__next-btn').forEach(button => {
        if (button.getAttribute('role') === 'button' && button.querySelector('a')) {
            button.removeAttribute('role');
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupRoleButtonRemoval);
} else {
    setupRoleButtonRemoval();
}

document.addEventListener('done-check-state-v2', function() {
    setTimeout(setupRoleButtonRemoval, 500);
});
